import React from "react";
import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";

const WrapperWithTabs = ({
  tabBarOptions = [],
  commonProps = {},
  componentBasedProps = {},
  wrapperClassName = "",
  tabSelected,
  setTabSelected,
}) => {
  const [selectedTab, setSelectedTab] = useState(tabBarOptions[0]);
  const {
    user: { userLabel },
  } = useAuth();
  const onTabSelect = (tab) => {
    if (setTabSelected) {
      setTabSelected(tab);
    } else {
      setSelectedTab(tab);
    }
  };

  const props = componentBasedProps?.[selectedTab?.id] || {};

  return (
    <div className={`tab-bar-wraper ${wrapperClassName}`}>
      <div className="flex gap-x-14 border-b-[1px] border-b-[var(--borderGray1)] overflow-x-scroll whitespace-nowrap">
        {tabBarOptions.map((item, index) => {
          if (item?.showTo && !item.showTo.includes(userLabel)) {
            return null;
          }
          return (
            <span
              className={`tab-option font-family-medium text-[2.4rem] ${
                (tabSelected || selectedTab)?.id === item?.id
                  ? "tab-option-active"
                  : ""
              }`}
              key={"tab-option-" + index}
              onClick={() => onTabSelect(item)}
            >
              {item?.title}
            </span>
          );
        })}
      </div>
      <div className="component-wrapper">
        {(tabSelected || selectedTab).Component ? (
          tabSelected?.Component ? (
            <tabSelected.Component {...commonProps} {...props} />
          ) : (
            <selectedTab.Component {...commonProps} {...props} />
          )
        ) : null}
      </div>
    </div>
  );
};

export default WrapperWithTabs;
